<mat-drawer-container class="structure-list"
                      (backdropClick)="deselectSelected()"
                      (dragover)="this.blockDrop($event)"
                      (drop)="this.blockDrop($event)"
                      autosize>
    <mat-drawer mode="side"
                position="start"
                [opened]="this.ShowTree">
        <div id="tree-drawer-keyboard-focus-div" tabindex="-1"></div>

        <div class="tree-drawer">
            <!-- pharv - 1/4/2023 - simplified use of app-folder-tree -->
            <app-folder-tree [site]="site"
                             (nodeSelected)="this.displayEntity($event)"
                             (itemMoved)="this.doOnItemMoved($event, true)"
                             [path]="this.FolderPath"
                             [treeIsStale]="this.TreeIsStale"></app-folder-tree>
            <!--
                     [pinnedOpen]="this.PinTreeOpen"
            -->
        </div>
    </mat-drawer>
    <mat-drawer #details
                mode="over"
                position="end"
                (keydown.escape)="this.deselectSelected()"
                [opened]="
                    this.SelectedFormInstance != null ||
                    this.SelectedFolder != null ||
                    this.RolesTargetFolder != null"
                (closedStart)="this.drawerClosing()">
        <mat-toolbar>
            <span>{{DetailsDrawerTitle}}</span>
            <span class="info-drawer-toolbar-spacer"></span>
            <button mat-icon-button (click)="this.deselectSelected()" tabindex="-1"><mat-icon>close</mat-icon></button>
        </mat-toolbar>
        <div id="details-drawer-keyboard-focus-div" tabindex="-1"></div>
        <div [ngClass]="{
             'details':this.SelectedFormInstance != null || this.SelectedFolder != null,
             'permissions-drawer':this.RolesTargetFolder != null}">
            <app-folder-details *ngIf="ShowFolderProperties"
                                [drawerComponentLiaison]="this.DrawerComponentLiaison"></app-folder-details>

            <app-form-instance-details *ngIf="ShowFormInstanceProperties"
                                       [drawerComponentLiaison]="this.DrawerComponentLiaison"></app-form-instance-details>

            <app-role-viewer *ngIf="ShowRoles"
                             (close)="this.deselectRolesTargetFolder($event)"
                             [drawerComponentLiaison]="this.DrawerComponentLiaison"></app-role-viewer>

            <app-toggle-favorite *ngIf="ShowToggleFavorite"
                                 class="toggle-favorite-pane"
                                 [drawerComponentLiaison]="this.DrawerComponentLiaison"></app-toggle-favorite>

        </div>
    </mat-drawer>
    <mat-drawer-content id="mat-drawer-content" (contextmenu)="onMainPanelContextMenu($event)">
        <div class="breadcrumbs noprint">
            <app-breadcrumbs *ngIf="this.ShowAppChrome && this.ShowStructure"
                             [currentFolder]="this.CurrentFolder"
                             [currentFormInstance]="this.CurrentFormInstance"
                             [dragEvent]="this.draggedItems"
                             (itemMoved)="this.doOnItemMoved($event)"></app-breadcrumbs>
        </div>
        <app-list-view *ngIf="ShowFolderList"
                       class="site-structure"
                       [heading]="this.CurrentFolder !== this.RootFolder ? this.CurrentFolder.name : null"
                       [list]="this.ListItems"
                       [totalListCount]="TotalListCount"
                       [buttonConfig]="this.ButtonConfig"
                       [listViewLiaison]="this.ListViewLiaison"
                       (contextmenu)="this.onListViewContextMenu($event)"
                       (itemContextMenu)="this.onListViewItemContextMenu($event)">
        </app-list-view>
        <app-context-menu #listViewItemContextMenuComponent
                          [contextMenuData]="this.ItemContextMenuData"
                          [menuName]="'listViewItemContextMenuComponent'"
                          style="visibility: hidden; position: fixed"></app-context-menu>
        <app-context-menu #listViewContextMenuComponent
                          [contextMenuData]="this.PageContextMenuData"
                          [menuName]="'listViewContextMenuComponent'"
                          style="visibility: hidden; position: fixed"></app-context-menu>
        <app-context-menu #mainPanelContextMenuComponent
                          [contextMenuData]="this.MainPanelContextMenuData"
                          [menuName]="'mainPanelContextMenuComponent'"
                          style="visibility: hidden; position: fixed"></app-context-menu>

        <!-- Display FormInstance -->
        <ng-container *ngIf="ShowFormInstance && ShowHistory">
            <app-form-instance-history [historyItem]="CurrentFormInstance"
                                       [formInstance]="CurrentFormInstance"
                                       (close)="onCloseHistory($event)"
                                       (restore)="onFormInstanceRestore($event)"
                                       (view)="onViewFormInstanceVersion($event)">
            </app-form-instance-history>
        </ng-container>

        <ng-container *ngIf="ShowFormInstance">
            <div class="print-form-title">{{this.CurrentFormInstance.name}}</div>
            <mat-toolbar class="tools noprint">
                <div class="left">
                    <button *ngFor="let btn of this.ButtonConfig.left"
                            mat-button
                            disabled="{{btn.disabled}}"
                            (click)="this.doOnButtonClick({ originalEvent: $event, button: btn.value, buttonConfig: btn})">
                        <span *ngIf="btn.icon == null">{{btn.label}}</span>
                        <mat-icon *ngIf="(btn.icon != null) && (btn.iconFormat == 'MatIcon')" title="{{btn.label}}">{{btn.icon}}</mat-icon>
                        <mat-icon *ngIf="(btn.icon != null) && (btn.iconFormat == 'SvgIcon')" svgIcon="{{btn.icon}}" class="default-svg-styling" title="{{btn.label}}"></mat-icon>
                    </button>
                </div>
                <div class="right" id="formInstanceButtons">
                    <ng-container *ngFor="let btn of this.ButtonConfig.formInstanceButtons">
                        <button mat-button
                                (click)="this.doOnButtonClick({ originalEvent: $event, button: btn.value, buttonConfig: btn})">
                            <span *ngIf="btn.icon == null">{{btn.label}}</span>
                            <mat-icon *ngIf="(btn.icon != null) && (btn.iconFormat == 'MatIcon')" title="{{btn.label}}">{{btn.icon}}</mat-icon>
                            <mat-icon *ngIf="(btn.icon != null) && (btn.iconFormat == 'SvgIcon') && (btn.inlineStyles == null)" svgIcon="{{btn.icon}}" class="default-svg-styling" title="{{btn.label}}"></mat-icon>
                            <mat-icon *ngIf="(btn.icon != null) && (btn.iconFormat == 'SvgIcon') && (btn.inlineStyles != null)" svgIcon="{{btn.icon}}" class="default-svg-styling" title="{{btn.label}}" style="{{btn.inlineStyles}}"></mat-icon>
                        </button>
                    </ng-container>
                </div>
            </mat-toolbar>
            <div class="form-instance-info">
                <div class="title">
                    <app-entity-name-editor [entity]="this.CurrentFormInstance"
                                            [entityType]="'FormInstance'"
                                            [suffix]="this.ReadOnlyText"
                                            [renameService]="this.FormInstanceService"
                                            [maxLength]="256"
                                            (done)="handleFormInstanceNameChange($event)">
                    </app-entity-name-editor>
                </div>
                <div class="workflow-status">Workflow Status: {{CurrentFormInstanceStatus}}</div>
            </div>

            <app-form-filler #formFiller
                             [formInstance]="this.CurrentFormInstance"
                             (save)="this.updateFormInstance($event)"
                             (updateFormInstance)="this.updateFormInstance($event)">
            </app-form-filler>
        </ng-container>

        <div (drop)="droppedFiles($event)"
             (dragover)="allowDrop($event)"
             class="fill-remaining">
        </div>
    </mat-drawer-content>
</mat-drawer-container>
